import { CameraAlt, Upload } from "@mui/icons-material";
import { CircularProgress, IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { fileUploadService } from "../services/s3-service";
import CameraCapture from "./CameraCapture";
import CtrlFillLabelTxtField from "./CtrlFillLabelTxtField";
import { notify } from "./notify";



// multiple: select/upload several files at once; onUpload receives
//   { fieldName, fileKeys: [...] } (accumulated) instead of { fieldName, fileKey }.
// withCamera (default true): camera icon opens webcam capture; captured pages are
//   uploaded and appended (multi) or replace the key (single).
function Fileupload({ txtFieldProps, name, title, errMsg, onUpload, width, multiple, withCamera = true, accept }) {
    const [loading, setLoading] = useState(false);
    const [cameraOpen, setCameraOpen] = useState(false);
    const [keys, setKeys] = useState([]);
    const { t } = useTranslation();

    function emit(newKeys) {
        setKeys(newKeys);
        if (multiple)
            onUpload({ fieldName: name, fileKeys: newKeys });
        else
            onUpload({ fieldName: name, fileKey: newKeys[newKeys.length - 1] ?? null });
    }

    async function handleFileUpload(e) {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;
        setLoading(true)
        try {
            const uploaded = [];
            for (const f of files)
                uploaded.push(await fileUploadService(f));
            emit(multiple ? [...keys, ...uploaded] : [uploaded[uploaded.length - 1]]);
        } catch (error) {
            // console.log(error)
            if (!multiple) onUpload({ fieldName: name, fileKey: null })
            if (error === "apiError")
                notify("error", "Error in File Uploading...");
        }
        setLoading(false)
    }

    function handleCaptured(capturedKeys) {
        emit(multiple ? [...keys, ...capturedKeys] : [capturedKeys[capturedKeys.length - 1]]);
    }

    return (
        <Stack>
            <CtrlFillLabelTxtField width={width} type={"file"} name={name} title={title} {...txtFieldProps}
                multiple={multiple} accept={accept}
                onChange={handleFileUpload} errMsg={errMsg} endAdornment=
                <InputAdornment position={"end"} >
                    {loading ? <CircularProgress size={20} /> : <Upload color='primary' />}
                    {withCamera &&
                        <IconButton size='small' onClick={() => setCameraOpen(true)} title={t("bo.fileUpload.captureTitle")}>
                            <CameraAlt color='primary' fontSize='small' />
                        </IconButton>}
                </InputAdornment>
            />
            {multiple && keys.length > 0 &&
                <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.3 }}>
                    {keys.length} {t("bo.fileUpload.filesSelected")}
                </Typography>}
            {withCamera &&
                <CameraCapture open={cameraOpen} handleClose={() => setCameraOpen(false)} onCaptured={handleCaptured} />}
        </Stack>
    )
}

export default Fileupload
